module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hollandsnieuwe-intro-card1.2@2x.421eb386.jpg";